import { useState, useEffect } from "react";
import FormInput from "../../../../components/Form/FormInput";
import CheckboxField from "../../../../components/Form/CheckboxField";
import SystemValueForm from "../../../../components/SystemValue/SystemValueForm";

const ServiceForm = ({ serviceToEdit, onSave, onCancel }) => {
  const [formData, setFormData] = useState({ name: "", active_flag: true });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (serviceToEdit) {
      setFormData({
        name: serviceToEdit.name,
        active_flag: serviceToEdit.active_flag,
      });
    } else {
      setFormData({ name: "", active_flag: true });
    }
  }, [serviceToEdit]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name === "name" && !value.trim()) {
      setErrors((prev) => ({ ...prev, name: "Service Name is required." }));
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      setErrors({ name: "Service Name is required." });
      return;
    }
    onSave(formData);
  };

  return (
    <SystemValueForm
      title={serviceToEdit ? "Edit Service" : "Add Service"}
      onSubmit={handleFormSubmit}
      onCancel={onCancel}
    >
      <FormInput
        label="Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.name}
        required
      />
      <CheckboxField
        label="Active"
        name="active_flag"
        checked={formData.active_flag}
        onChange={handleChange}
      />
    </SystemValueForm>
  );
};

export default ServiceForm;
